import React from "react";

export const Electricity = () => (
  <svg viewBox="0 0 512 512">
    <path
      d="M303.03,36.52c0,4.45,0.15,8.9-0.03,13.34c-0.37,9.33-1.7,17.56,12.94,17.88
	c9.4,0.2,14.56,9.56,14.61,19.54c0.13,31.13,0.57,62.28-0.18,93.4c-0.48,19.87-16.48,35.29-36.23,34.54
	c-12.93-0.49-20.19,1.36-21.36,16.35c-0.8,10.27-8.22,18.74-14.68,26.97c-15.11,19.24-15.12,31.83-0.47,50.84
	c24.4,31.66,24.24,59.86-0.52,91.77c-13.79,17.76-13.95,31.51,0.17,49.06c9.5,11.81,16.5,24.5,18.12,39.81
	c1.31,12.34-3.71,20.61-13.46,21.81c-10.24,1.26-16.14-4.31-17.57-17.6c-1.05-9.76-6.16-17.18-11.92-24.56
	c-22.75-29.13-22.64-59.15,0.17-88.3c15.65-19.99,15.69-32.87,0.17-52.56c-23.16-29.38-23.11-59.52,0.16-89.19
	c0.69-0.87,1.34-1.78,2-2.67c4.38-5.94,11.21-12.63,7.46-19.53c-2.63-4.84-11.59-1.71-17.68-1.76
	c-29.65-0.22-43.49-13.91-43.5-43.55c-0.01-26.32-0.03-52.63,0.01-78.95c0.02-18.74,3.95-23.82,22.08-26.58
	c5.4-0.82,5.52-3.59,5.51-7.51c-0.04-14.08,0.11-28.17-0.05-42.25c-0.11-9.62,3.91-15.7,13.79-16.73
	c9.23-0.96,16.33,4.72,16.95,15.01c0.87,14.4,0.7,28.89,0.37,43.33c-0.15,6.43,2.09,8,8.28,8.13c24.31,0.48,24.3,0.7,24.3-23.29
	c0-8.9-0.2-17.8,0.06-26.68c0.31-10.54,6.05-16.52,15.34-16.56c9.52-0.04,14.91,5.71,15.15,16.46
	C303.16,23.17,303.03,29.84,303.03,36.52z"
    />
  </svg>
);
